
// Fix: Standardize Firebase imports by separating types and values
import { initializeApp, getApps, getApp } from "firebase/app";
import type { FirebaseApp } from "firebase/app";
import { getAuth, initializeAuth, browserLocalPersistence } from "firebase/auth";
import type { Auth } from "firebase/auth";
import { initializeFirestore, getFirestore } from "firebase/firestore";
import type { Firestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

const DB_NAME = import.meta.env.VITE_FIRESTORE_DB_NAME || 'gaiadb';

let app: FirebaseApp;
let auth: Auth;
let db: Firestore;

if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApp();
}

try {
  auth = getAuth(app);
} catch (e) {
  auth = initializeAuth(app, {
    persistence: browserLocalPersistence
  });
}

// データベース接続の遅延初期化と取得を行う関数
export const getDb = (): Firestore => {
    if (!db) {
        try {
            // 指定されたデータベース名で取得を試みる
            db = getFirestore(app, DB_NAME);
        } catch (e) {
            // 初期化されていない場合は設定付きで初期化
            try {
                db = initializeFirestore(app, {
                    experimentalForceLongPolling: true,
                }, DB_NAME);
            } catch (e2) {
                console.error("Named DB init failed, trying default:", e2);
                // 最悪の場合はデフォルトDBへフォールバック
                db = getFirestore(app);
            }
        }
    }
    return db;
};

// 初回呼び出しでインスタンス生成
try {
    getDb();
} catch(e) {
    console.error("Firebase DB init error", e);
}

export const isConfigured = true;
export { app, auth };
export default app;
